<template>
  <transition
    enter-active-class="transform ease-out duration-300 transition"
    enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
    enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
    leave-active-class="transition ease-in duration-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
    appear
    @after-leave="$emit('dismiss')"
  >
    <div v-if="show" class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <CheckCircleIcon v-if="type === SUCCESS" class="h-6 w-6 text-green-400" aria-hidden="true" />
            <ExclamationCircleIcon v-else-if="type === WARNING" class="h-6 w-6 text-yellow-400" aria-hidden="true" />
            <ExclamationCircleIcon v-else-if="type === ERROR" class="h-6 w-6 text-red-400" aria-hidden="true" />
            <InformationCircleIcon v-else class="h-6 w-6 text-gray-400" aria-hidden="true" />
          </div>

          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-sm font-medium text-gray-900">
              {{ title }}
            </p>
            <p v-if="message" class="mt-1 text-sm text-gray-500">
              {{ message }}
            </p>
          </div>

          <div class="ml-4 flex flex-shrink-0">
            <button
              type="button"
              class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              @click="show = false"
            >
              <span class="sr-only">Close</span>
              <XIcon class="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
  XIcon,
} from '@heroicons/vue/outline';

import {
  ERROR, WARNING, SUCCESS, NOTICE,
} from '@/store/modules/notifications';

export default {
  components: {
    CheckCircleIcon,
    ExclamationCircleIcon,
    InformationCircleIcon,
    XIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: NOTICE,
    },
  },
  emits: ['dismiss'],
  data() {
    return {
      show: true,
      ERROR,
      WARNING,
      SUCCESS,
      NOTICE,
    };
  },
};
</script>
